export const STARTER_PRODUCT_KEY = "starter";

const starterPrices = {
  monthlyPrice: 100,
  annualPrice: 1100,
};

export const getStarterPrice = (cadence: "month" | "year") =>
  cadence === "year" ? starterPrices.annualPrice : starterPrices.monthlyPrice;

export const isCreditFeature = (text: string) => /\bcredits?\b/i.test(text);
